
import { defineComponent } from 'vue';
import { Custom_Field_Definition, Custom_Field_Definition_Type } from '@/schema/custom_fields';
import CustomFieldLabel from '@/components/_CustomFields/CustomFieldLabel.vue';

export default defineComponent({
	components: {
		CustomFieldLabel
	},
	props: {
		customFieldDefinitions: {
			type: Array as () => Custom_Field_Definition[],
			required: true
		},
		change: {
			type: Function as () => void,
			required: true
		}
	},
	data() {
		return {
			selectedFilters: {},
			Custom_Field_Definition_Type: Custom_Field_Definition_Type
		};
	},
	computed: {
		customFieldsFilter() {
			return {
				_contains: Object.keys(this.selectedFilters).filter(key => this.selectedFilters[key] !== '').reduce((acc, key) => {
					// Split the key by dot to get the nested levels
					const path = key.split('.');
					let current = acc; // Start with the accumulator

					// Iterate over the path to create nested objects
					path.forEach((part, index) => {
						// Check if we're at the last part of the path
						if (index === path.length - 1) {
							// Set the value at the last part of the path
							current[part] = this.selectedFilters[key];
						} else {
							// If the part doesn't exist, create an empty object at this part
							if (!current[part]) {
								current[part] = {};
							}
							// Move to the next level of the path
							current = current[part];
						}
					});

					return acc; // Return the accumulated object
				}, {}) // Initial value of the accumulator is an empty object
			};
		}
	},
	methods: {
		handleChange() {
			this.change(this.customFieldsFilter);
		}
	}
});
